import React, { useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl';
import { useMeetingStore } from '../../../stores/MeetingsStore';
import { useSettingsStore } from '../../../stores/SettingsStore';
import useUser from '../../../hooks/User';
import { useCustomeStore } from '../../../stores/CustomeStore';
import { useMerchantStore } from '../../../stores/MerchantStore';
import { usePipelineStore } from '../../../stores/PipelineStore';
import useClearInputByRef from '../../../hooks/useClearInputByRef';
import { SelectOption } from '../../../interfaces/SelectOption';
import { useDataTableStore } from '../../../stores/DataTableStore';
import useAccessToken from '../../../hooks/AccessToken';
import { CustomField, CustomFieldSerialProps } from '../../../interfaces/Settings';
import { AddMerchant } from '../../Merchants/AddMerchant';
import useHandleCloseModal from '../../../hooks/HandleCloseModal';
import { useFormik } from 'formik';
import { User } from '../../../interfaces/User';
import { UserCompany } from '../../../interfaces/UserCompany';
import * as Yup from 'yup';
import { customNumberFormatReminderMeeting, dataURLtoFile, getDataById, getRandomFileName, handleCaps, isValidUrl, unformatNumberInput } from '../../../functions/general';
import { KTSVG } from '../../../_metronic/helpers';
import Select from "react-select"
import clsx from 'clsx';
import { DatePicker } from 'rsuite';
import moment from 'moment-timezone';
import { isAfter, isBefore, startOfToday } from 'date-fns';
import MapLocationMeeting from '../MapLocationMeeting';
import RenderCustomFieldGeneralForm from '../../RenderComponent/RenderCustomFieldGeneralForm';
import { Merchant } from '../../../interfaces/Merchant';
import { Modal } from "bootstrap";
import Swal from 'sweetalert2';
import { insertAttachment, insertMultiAttachment } from '../../../api/ResourceAPI';
import { generateSerialApi } from '../../../api/Generals';
import { MeetingAttachment } from '../../../interfaces/Meeting';
import { insertMeeting } from '../../../api/MeetingsCRUD';
import InputAttachment from '../../Input/InputAttachment';
import { CapturePhoto } from '../../Attendance/CapturePhoto';
import useCamera from '../../../hooks/Camera';
import { getStatusMeeting, handleCoordinate } from '../../../functions/meeting';
import { Buffer } from 'buffer';
import { useParams } from 'react-router-dom';
import { useProductStore } from '../../../stores/ProductStore';
import VirtualizedSelect from '../../Select/SelectVirtualized';
import useGroupMerchantMeeting from '../../../hooks/useGroupMerchantMeeting';
import { useGoogleAccountStore } from '../../../stores/GoogleAccount';
import { returnTypeMeeting } from '../../General/DetailMasterElement';


interface AddReportMeetingProps {
  startDate: Date | null
  endDate: Date | null
  setStartDate: React.Dispatch<React.SetStateAction<Date | null>>
  setEndDate: React.Dispatch<React.SetStateAction<Date | null>>
  typeMeeting: string
  setTypeMeeting: (typeMeeting: 'schedule' | 'visit' | 'report' | 'schedule-visit') => void
  customFields: CustomField
  setCustomFields: React.Dispatch<React.SetStateAction<CustomField>>
  usersData: SelectOption[]
  users: User[]
  labels: any
  usersCompany: UserCompany[]
  usersCompanyLoading?: boolean
  usersLoading?: boolean
}

const AddReportMeeting = ({ startDate, endDate, setStartDate, setEndDate, typeMeeting, setTypeMeeting, customFields, setCustomFields, usersData, users, labels, usersCompany, usersLoading, usersCompanyLoading }: AddReportMeetingProps) => {
  const intl = useIntl()
  const closeModalRef = React.useRef<HTMLButtonElement>(null)
  const modalRef = useRef<HTMLDivElement | null>(null);
  const { selectMultiMeeting, simpleMeetings } = useMeetingStore();
  const { settings } = useSettingsStore()
  const user = useUser();
  const { companyId } = useCustomeStore()
  const { simpleMerchants } = useMerchantStore()
  const { simplePipelines } = usePipelineStore()
  const { simpleProducts } = useProductStore()
  const [isAllDay, setIsAllDay] = useState(true);
  const [showAddMerchantModal, setShowAddMerchantModal] = useState<boolean>(false);
  const { resetCustomFieldInputs } = useClearInputByRef()
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [latitudeMap, setLatitudeMap] = useState<number>(0);
  const [longitudeMap, setLongitudeMap] = useState<number>(0);
  const [optionsLocation, setOptionsLocation] = useState<SelectOption[]>([]);
  const refArray = useRef<(HTMLInputElement | null)[]>([]);
  const [labelsOption, setLabelOption] = useState([])
  const [userCompanyData, setUserCompanyData] = useState<SelectOption[]>([]);
  const [dataCustomFieldSerial, setDataCustomFieldSerial] = useState<CustomFieldSerialProps>({});
  const { tablesData, setTablesData } = useDataTableStore()
  const token = useAccessToken()
  const camera = useCamera()
  const [capturePhoto, setCapturePhoto] = useState(null);
  const { templateMeetingId } = useParams()
  const [toGoogleCalendar, setToGoogleCalendar] = useState(false);
  const { googleAccount } = useGoogleAccountStore()

  const { merchantData, merchantsLoading } = useGroupMerchantMeeting()

  const formSchema = Object.keys(customFields).reduce((obj: any, item: string) => {
    const field = customFields[item];
    const isRequiredMessage = intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: field.name });
    const isValidUrlMessage = intl.formatMessage({ id: "FORM.VALIDATION.MUST_LINK" });

    if (field.type === 'multiple' || field.type === 'multipleOption' || field.type === 'images' || field.type === 'files' || field.type === 'videos' || field.type === 'merchant' || field.type === 'user' || field.type === 'meeting' || field.type === 'product') {
      obj[item] = field.required && typeMeeting === 'report'
        ? Yup.array().min(1, isRequiredMessage).required(isRequiredMessage).nullable()
        : Yup.array().notRequired().nullable();
    } else if (field.type === 'date') {
      obj[item] = field.required && typeMeeting === 'report'
        ? Yup.string().required(isRequiredMessage).nullable()
        : Yup.string().notRequired().nullable();
    } else if (field.type === 'link') {
      obj[item] = field.required && typeMeeting === 'report'
        ? Yup.string().nullable().required(isRequiredMessage).test('is-required', isValidUrlMessage, function (value) {
          return !value || isValidUrl(value);
        })
        : Yup.string().nullable().test('is-required', isValidUrlMessage, function (value) {
          return !value || isValidUrl(value);
        });
    } else if (field.type === 'serial') {
      obj[item] = Yup.array().notRequired().nullable();
    } else if (field.type === 'dateTimeRange') {
      if (field.required && typeMeeting === 'report') {
        obj[item] = Yup.array().min(1, isRequiredMessage).required(isRequiredMessage).nullable();
      } else {
        obj[item] = Yup.array().notRequired().nullable();
      }
    } else if (field.type === 'email') {
      obj[item] = field.required && typeMeeting === 'report'
        ? Yup.string().email(intl.formatMessage({ id: "FORM.VALIDATION.EMAIL" })).required(isRequiredMessage).nullable()
        : Yup.string().email(intl.formatMessage({ id: "FORM.VALIDATION.EMAIL" })).notRequired().nullable();
    } else {
      obj[item] = field.required && typeMeeting === 'report'
        ? Yup.string().required(isRequiredMessage).nullable()
        : Yup.string().notRequired().nullable();
    }

    return obj;
  }, {});

  const validationSchema = Yup.object().shape({
    merchant: Yup.string().required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: settings.merchant_title })),
    labels: Yup.array().notRequired(),
    dateStart: Yup.string().required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.DATE" }, { title: settings.meeting_title + ' ' + selectMultiMeeting.name }) })).nullable(),
    dateEnd: Yup.string().required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.DATE" }, { title: settings.meeting_title + ' ' + selectMultiMeeting.name }) })).nullable(),
    ownerId: Yup.string().required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.PIC" }) })),
    attachment: Yup.string().nullable().test('is-required', intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.PHOTO" }, { title: selectMultiMeeting.name }) }), function (value) {
      if (typeMeeting === 'report' && !settings.meeting_done_disable_capture_camera) {
        return !!value;
      } else if (typeMeeting === 'visit' && !settings.meeting_visit_disable_capture_camera) {
        return !!value;
      }
      return true;
    }),
    location: Yup.mixed().required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.LOCATION" }) })),
    reminder: Yup.string().notRequired().nullable(),
    note: Yup.string().notRequired().nullable(),
    userAttendees: user?.data.company_id === companyId.maxy ? Yup.array().min(1, intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" },
      { title: intl.formatMessage({ id: "FORM.LABEL.PARTICIPANT" }) })).required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" },
        { title: intl.formatMessage({ id: "FORM.LABEL.PARTICIPANT" }) })).nullable() :
      Yup.array().notRequired().nullable(),
    ...formSchema
  });

  const initialValues = {
    merchant: '',
    labels: '',
    dateStart: '',
    dateEnd: '',
    ownerId: user.data.permission_meeting_create !== 'TEAM' && user.data.permission_meeting_create !== 'ALL' ? user.data.name : '',
    attachment: '',
    location: '',
    status: '',
    reminder: '',
    note: '',
    userAttendees: [] as SelectOption[],
    ...Object.fromEntries(Object.keys(customFields).map((key) => [key, null])),
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      let dateStart = moment(values.dateStart).format('YYYY-MM-DD');
      let dateStartTime = moment(values.dateStart).format('YYYY-MM-DD HH:mm');
      let nowDate = moment().format('YYYY-MM-DD');
      let nowDateTime = moment().format('YYYY-MM-DD HH:mm');

      const convertCustomFields: Record<string, any> = Object.keys(customFields).reduce(
        (obj, item) => {
          if (!obj.info_custom_fields) {
            obj.info_custom_fields = {};
          }

          if (customFields[item].type === 'merchant') {
            const selectedMerchants = getDataById(values[item as keyof typeof values] as any, simpleMerchants);
            obj[`custom_fields.${item}`] = selectedMerchants?.map((merchant: any) => merchant.name).join(", ");
            obj.info_custom_fields[item] = selectedMerchants?.map((merchant: any) => ({
              merchant_template_id: merchant.merchantTemplateId,
              merchant_id: merchant.id,
              merchant_name: merchant.name
            })) || [];
          }
          else if (customFields[item].type === 'user') {
            const selectedUsers = getDataById(values[item as keyof typeof values] as any, users);
            obj[`custom_fields.${item}`] = selectedUsers?.map((user: any) => user.name).join(", ");
            obj.info_custom_fields[item] = selectedUsers?.map((user: any) => ({
              id: user.id,
              name: user.name
            })) || [];
          }
          else if (customFields[item].type === 'pipeline') {
            const selectedPipeline = getDataById(values[item as keyof typeof values] as string, simplePipelines);
            obj[`custom_fields.${item}`] = selectedPipeline ?
              `${selectedPipeline.name} / ${selectedPipeline.nominal} / ${moment(selectedPipeline.dateCreated).format('DD MMM YYYY')}`
              : '-';
            obj.info_custom_fields[item] = selectedPipeline ? [{
              id: selectedPipeline.id,
              name: selectedPipeline.name,
              nominal: selectedPipeline.nominal,
              dateCreated: selectedPipeline.dateCreated
            }] : [];
          }
          else if (customFields[item].type === 'meeting') {
            const selectedMeeting: any[] = getDataById(values[item as keyof typeof values] as string, simpleMeetings);
            obj[`custom_fields.${item}`] = selectedMeeting && selectedMeeting.length > 0 ?
              selectedMeeting.map((meeting: any) => `${meeting.name} / ${moment(meeting.dateMeet).format('DD MMM YYYY')} / ${meeting.meetingStatus}`).join(', ')
              : '-';
            obj.info_custom_fields[item] = selectedMeeting && selectedMeeting.length > 0 ? selectedMeeting.map((meeting: any) => ({
              meeting_template_id: meeting.meetingTemplateId,
              id: meeting.id,
              merchant_name: meeting.name,
              date_meet: meeting.dateMeet,
              meeting_status: meeting.meetingStatus
            })) : [];
          } else if (customFields[item].type === 'product') {
            const selectedProducts = getDataById(values[item as keyof typeof values] as any, simpleProducts);
            obj[`custom_fields.${item}`] = selectedProducts?.map((product: any) => product.name).join(", ");
            obj.info_custom_fields[item] = selectedProducts?.map((product: any) => ({
              product_id: product.id,
              product_name: product.name,
              product_prices: product.product_prices,
            })) || [];
          }
          else {
            obj[`custom_fields.${item}`] = values[item as keyof typeof values] || '';
            obj.info_custom_fields[item] = [];
          }

          return obj;
        },
        {} as Record<string, any>
      );

      if (isAllDay && moment(dateStart).isAfter(nowDate)) {
        Swal.fire({
          icon: "error",
          title: `${intl.formatMessage({ id: 'FORM.VALIDATION.EXECEED_TODAY' })}`,
          heightAuto: false,
          target: document.getElementById('add-report-meeting-modal'),
          confirmButtonText: 'Ok'
        })

        return false
      } else if (!isAllDay && moment(dateStartTime).isAfter(nowDateTime)) {
        Swal.fire({
          icon: "error",
          title: `${intl.formatMessage({ id: 'FORM.VALIDATION.EXECEED_HOUR' })}`,
          heightAuto: false,
          target: document.getElementById('add-report-meeting-modal'),
          confirmButtonText: 'Ok'
        })

        return false
      }

      if (!isAllDay && new Date(values.dateEnd).getTime() < new Date(values.dateStart).getTime()) {
        Swal.fire({
          icon: "error",
          title: intl.formatMessage({ id: "FORM.VALIDATION.END_DATE_OR_HOUR" }),
          heightAuto: false,
          target: document.getElementById('add-report-meeting-modal'),
          confirmButtonText: 'Ok'
        })

        return false
      }

      let pic_name = user.data.permission_meeting_create === 'TEAM' || user.data.permission_meeting_create === 'ALL' ? usersData.find(option => option.value === values.ownerId)?.label : user.data.name

      Swal.fire({
        title: intl.formatMessage({ id: 'FORM.VALIDATION.CONFIRMATION' }),
        html: intl.formatMessage({ id: 'FORM.VALIDATION.DESC_CONFIRMATION_DATA' }),
        icon: "question",
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: intl.formatMessage({ id: 'FORM.CONFIRMATION.YES' }),
        cancelButtonText: intl.formatMessage({ id: 'FORM.CONFIRMATION.NO' }),
        customClass: {
          confirmButton: "btn btn-color-primary",
          cancelButton: "btn btn-active-color-gray-400",
        },
        reverseButtons: true,
        heightAuto: false,
        target: document.getElementById('add-report-meeting-modal'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          setSubmitting(true)

          // Assuming values is of type Record<string, string> and customFields is of type fieldCustom
          const customFieldsValues: Record<string, string | string[] | number | null> = Object.keys(customFields).reduce(
            (obj, item) => ({
              ...obj,
              [item]: (values as Record<string, string | string[] | number | SelectOption[] | null>)[item],
            }),
            {}
          );

          // Use Promise.all to await all async operations
          var countResourceError = 0
          await Promise.all(
            Object.keys(customFields).map(async (key) => {
              if (customFields[key].type === 'image' || customFields[key].type === 'file' || customFields[key].type === 'video') {
                try {
                  const resourceResponse = await insertAttachment(values[key as keyof typeof values] as any, 'MEETING', token);
                  if (resourceResponse.data.success) customFieldsValues[key] = resourceResponse.data.data.length > 0 ? resourceResponse.data.data[0] : null;
                  else countResourceError++
                } catch (error) {
                  countResourceError++
                }
              } else if (customFields[key].type === 'images' || customFields[key].type === 'files' || customFields[key].type === 'videos') {
                try {
                  if (values[key as keyof typeof values]) {
                    const resourceResponse = await insertMultiAttachment(values[key as keyof typeof values] as any, 'MEETING', token);
                    if (resourceResponse.data.success) customFieldsValues[key] = resourceResponse.data.data.length > 0 ? resourceResponse.data.data : null;
                    else countResourceError++
                  }
                } catch (error) {
                  countResourceError++
                }
              } else if (customFields[key].type === 'multiple' || customFields[key].type === 'multipleOption') {
                var multipleValues = values[key as keyof typeof values]?.length! > 0 ? values[key as keyof typeof values] : null;
                customFieldsValues[key] = multipleValues as string
              } else if (customFields[key].type === 'dateTimeRange') {
                if (values[key as keyof typeof values]) {
                  const [startDate, endDate] = values[key as keyof typeof values] as any;
                  customFieldsValues[key] = [
                    startDate ? (new Date(startDate).toISOString() as any) : null,
                    endDate ? (new Date(endDate).toISOString() as any) : null
                  ];
                } else {
                  customFieldsValues[key] = null;
                }
              } else if (customFields[key].type === 'serial') {
                try {
                  if (dataCustomFieldSerial[key].value.length === 0) {
                    const serialResponse = await generateSerialApi(key, "Meeting", token);
                    customFieldsValues[key] = serialResponse.data.success ? serialResponse.data.data : null;
                  } else {
                    customFieldsValues[key] = dataCustomFieldSerial[key].value
                  }
                } catch (error) {
                  countResourceError++
                }
              } else if (customFields[key].type === 'number') {
                const stringValue = values[key as keyof typeof values] as string;
                customFieldsValues[key] = stringValue ? unformatNumberInput(stringValue) : null;
              }
            })
          );

          values.status = "COMPLETED"

          if (countResourceError > 0) {
            Swal.fire({
              icon: "error",
              text: `${intl.formatMessage({ id: "FORM.VALIDATION.ADD_FAILED" })}.`,
              heightAuto: false,
              target: document.getElementById('add-report-meeting-modal'),
              confirmButtonText: 'Ok'
            })
            setSubmitting(false);
          } else {
            try {
              let attachments: MeetingAttachment[] = []
              if (values.attachment) {
                const resourceResponse = await insertAttachment(values.attachment, 'MEETING', token)
                if (resourceResponse.data.success) {
                  const parts = resourceResponse.data.data[0].split('/');
                  const fileName = parts[parts.length - 1];
                  attachments = [
                    {
                      name: fileName,
                      url: resourceResponse.data.data[0]
                    }
                  ]
                } else {
                  Swal.fire({
                    icon: "error",
                    text: resourceResponse.data.message,
                    heightAuto: false,
                    target: document.getElementById('add-report-meeting-modal'),
                    confirmButtonText: 'Ok'
                  })
                  setSubmitting(false);
                  return
                }
              }
              const meetingLabels = values.labels.length > 0 && Array.isArray(values.labels) ? values.labels.map((label) => { return { id: label } }) : []

              const response = await insertMeeting({
                meetingTemplateId: templateMeetingId as string,
                meetingLabels: meetingLabels,
                merchantId: values.merchant,
                start: {
                  date: isAllDay ? moment(`${values.dateStart}`).format("YYYY-MM-DD") : null,
                  dateTime: !isAllDay ? moment(`${values.dateStart}`).toISOString(true) : null
                },
                end: {
                  date: isAllDay ? moment(`${values.dateEnd}`).add(isAllDay ? 1 : 0, 'days').format("YYYY-MM-DD") : null,
                  dateTime: !isAllDay ? moment(`${values.dateEnd}`).add(isAllDay ? 1 : 0, 'days').toISOString(true) : null,
                },
                ownerId: user.data.permission_meeting_create === 'TEAM' || user.data.permission_meeting_create === 'ALL' ? values.ownerId : user.data.id,
                attachments: attachments,
                token: token,
                meetingStatus: values.status,
                note: values.note,
                reminderMinutes: values.reminder === "" ? null : values.reminder.split('.').join(''),
                userAttendees: values.userAttendees.reduce((acc: { id: string }[], e: { value: string, label: string }) => {
                  if (e.label !== pic_name) {
                    acc.push({ id: e.value });
                  }
                  return acc;
                }, []),
                sendNotification: false,
                latitude: String(latitudeMap),
                longitude: String(longitudeMap),
                location: values.location,
                customFields: customFieldsValues,
                toGoogleCalendar: toGoogleCalendar
              })
              if (response.data.success) {
                Swal.fire({
                  icon: "success",
                  title: intl.formatMessage({ id: "ALERT.TITLE.SUCCESS" }),
                  text: `${intl.formatMessage({ id: "FORM.VALIDATION.ADD_SUCCESS" })}.`,
                  // target: document.getElementById('add-report-meeting-modal'),
                  heightAuto: false,
                })

                if (moment(values.dateStart).isBefore(moment(startDate))) {
                  setStartDate(new Date(values.dateStart))
                } else if (moment(values.dateEnd).isAfter(moment(endDate))) {
                  setEndDate(new Date(values.dateEnd))
                } else {
                  setTablesData('meetings', ([
                    {
                      ...response.data.data,
                      ...convertCustomFields['custom_fields'],
                      info_custom_fields: convertCustomFields.info_custom_fields,
                      customFields: customFieldsValues,
                      date_meet: moment(response.data.data.date_meet).format("YYYY-MM-DD HH:mm:ss"),
                      date_meet_end: response.data.data.allDay ? moment(response.data.data.date_meet_end).subtract(1, 'days').local().format("YYYY-MM-DD HH:mm:ss") : moment(response.data.data.date_meet_end).format("YYYY-MM-DD HH:mm:ss"),
                      meeting_status: getStatusMeeting(response.data.data, intl),
                      allDay: response.data.data.allDay,
                      typeString: returnTypeMeeting(response.data.data, settings, intl)
                    },
                    ...tablesData.meetings,
                  ]))
                }

                closeModalRef.current?.click();
              }
            } catch (error: any) {
              Swal.fire({
                icon: 'error',
                title: error.response.data.message,
                confirmButtonText: 'Ok',
                target: document.getElementById('add-report-meeting-modal'),
                heightAuto: false,
              })
            } finally {
              setSubmitting(false)
            }
          }
        }
      })
    },
  })

  useEffect(() => {
    const newLabelsOption = labels.map((label: any) => { return { value: label.id, label: label.name } })
    setLabelOption(newLabelsOption)
  }, [labels])

  useEffect(() => {
    if (!usersCompanyLoading) {
      const userCompanyData = usersCompany.map((user: UserCompany) => ({
        value: user.id,
        label: user.ownerName,
      }));
      setUserCompanyData(userCompanyData)
    }
  }, [usersCompany]);
  const handleAttendeesChange = (selectedOptions: any) => {
    formik.setFieldValue('userAttendees', selectedOptions)
  };

  const handleReminderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedValue = customNumberFormatReminderMeeting(e.target.value);
    formik.setFieldValue('reminder', formattedValue);
  };

  const addMerchant = (merchant: Merchant) => {
    formik.setFieldValue("merchant", merchant.id)
  }

  useEffect(() => {
    handleCoordinate({ setLatitudeMap, setLongitudeMap, intl, formik })
  }, [typeMeeting])

  const handleTakePhoto = async () => {
    if (capturePhoto) {
      const img = new Image();
      img.onload = async () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (ctx) {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);

          const locationText = formik.values.location;
          const now = new Date();
          const dateText = moment(now).format("DD MMMM YYYY HH:mm:ss")

          const margin = 5;
          let fontSize = Math.max(10, Math.min(14, img.width / 50));
          ctx.font = `${fontSize}px Arial`;
          ctx.fillStyle = 'white';
          ctx.textAlign = 'right';
          ctx.textBaseline = 'bottom';
          ctx.strokeStyle = 'black';
          ctx.lineWidth = 1;

          const wrapText = (text: string, maxWidth: number) => {
            const words = text.split(' ');
            let lines = [];
            let currentLine = '';
            for (let i = 0; i < words.length; i++) {
              const testLine = currentLine ? `${currentLine} ${words[i]}` : words[i];
              const metrics = ctx.measureText(testLine);
              if (metrics.width > maxWidth && i > 0) {
                lines.push(currentLine);
                currentLine = words[i];
              } else {
                currentLine = testLine;
              }
            }
            lines.push(currentLine);
            return lines;
          };

          const maxWidth = img.width - 2 * margin;
          const locationLines = wrapText(locationText, maxWidth);
          let yPos = img.height - margin;
          const lineHeight = fontSize * 1.2;

          ctx.strokeText(dateText, img.width - margin, yPos);
          ctx.fillText(dateText, img.width - margin, yPos);
          yPos -= lineHeight;

          for (let i = locationLines.length - 1; i >= 0; i--) {
            ctx.strokeText(locationLines[i], img.width - margin, yPos);
            ctx.fillText(locationLines[i], img.width - margin, yPos);
            yPos -= lineHeight;
          }

          const labeledPhotoDataURL = canvas.toDataURL('image/jpeg');
          const file = dataURLtoFile(labeledPhotoDataURL, getRandomFileName() + '.jpeg', Buffer);

          formik.setFieldValue('attachment', file);

        }
      };

      img.src = capturePhoto;
    } else {
      formik.setFieldValue('attachment', null);
    }
  };

  useEffect(() => {
    // Get the modal element
    const modalElement = modalRef.current;

    // Define the event listener
    const handleModalHidden = () => {
      if (!showAddMerchantModal) {
        resetCustomFieldInputs()
        setTypeMeeting('' as 'schedule' | 'visit' | 'report' | 'schedule-visit')
        formik.resetForm()
        fileInputRef.current?.value && (fileInputRef.current.value = "")
        formik.setFieldValue('dateStart', '')
        formik.setFieldValue('dateEnd', '')
        formik.setFieldValue('hourStart', '')
        formik.setFieldValue('hourEnd', '')
        formik.setFieldValue('location', '')
        setLatitudeMap(0)
        setLongitudeMap(0)
        setOptionsLocation([])
        // setSelectedAttendees([])

        Object.keys(customFields).map((key, index) => {
          // Reset 
          const ref = refArray.current[index];
          if (ref && ref.value) {
            ref.value = "";
          }

          if (customFields[key].type === "multiple") {
            var checkboxes = document.getElementsByName(key)
            checkboxes.forEach((checkbox: any) => {
              checkbox.checked = false
            })
          }

          if (customFields[key].type === "date") {
            formik.setFieldValue(key, null)
          }
        });
      }
    };

    // Attach the event listener
    modalElement?.addEventListener('hidden.bs.modal', handleModalHidden);

    // Cleanup
    return () => {
      modalElement?.removeEventListener('hidden.bs.modal', handleModalHidden);
    };
  }, [formik, showAddMerchantModal, setShowAddMerchantModal]);

  useEffect(() => {
    if (showAddMerchantModal) {
      const modalElement = document.getElementById(`add-merchant-modal`);
      const modalElementAddMeeting = document.getElementById(`add-report-meeting-modal`);

      if (modalElement) {
        const modalInstance = new Modal(modalElement);
        const modalInstanceAddMeeting = new Modal(modalElementAddMeeting!);
        modalInstance.show();

        const handleModalHide = () => {
          setShowAddMerchantModal(false);
          modalInstanceAddMeeting.show()
        };

        modalElement.addEventListener('hidden.bs.modal', handleModalHide);

        return () => {
          modalElement.removeEventListener('hidden.bs.modal', handleModalHide);
        };
      }
    }
  }, [showAddMerchantModal, setShowAddMerchantModal]);

  const { handleCloseModal } = useHandleCloseModal(modalRef, closeModalRef, formik);

  return (
    <>
      <div className={`modal fade ${showAddMerchantModal ? 'hide' : 'show'}`} tabIndex={-1} id='add-report-meeting-modal' ref={modalRef}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{intl.formatMessage({ id: 'FORM.ACTION.ADD' })} {selectMultiMeeting.name}</h5>
              <div
                className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                onClick={handleCloseModal}
              >
                <KTSVG
                  path="/media/icons/duotune/arrows/arr061.svg"
                  className="svg-icon svg-icon-2x"
                />
              </div>
            </div>
            <form onSubmit={formik.handleSubmit} noValidate>
              <div className="modal-body">
                {formik.status && (
                  <div className='mb-lg-15 alert alert-danger'>
                    <div className='alert-text font-weight-bold'>{formik.status}</div>
                  </div>
                )}
                {/* PIC */}
                <label className='form-label fs-6 fw-bolder text-dark required'>{intl.formatMessage({ id: 'FORM.LABEL.PIC' })}</label>
                <div className="input-group mb-3">
                  {
                    (user.data.permission_meeting_create === 'TEAM' || user.data.permission_meeting_create === 'ALL') ? (
                      <Select
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999
                          })
                        }}
                        // key={nanoid()}
                        options={usersData}
                        placeholder={`${intl.formatMessage({ id: 'FORM.ACTION.CHOOSE' })} ${intl.formatMessage({ id: 'FORM.LABEL.PIC' })}`}
                        value={usersData.find(option => option.value === formik.values.ownerId) || null}
                        onChange={
                          option => formik.handleChange({
                            target: {
                              name: "ownerId",
                              value: option?.value || ""
                            }
                          })
                        }
                        onBlur={
                          () => formik.values.ownerId === "" && formik.setFieldTouched("ownerId", true)
                        }
                        className="w-100 z-index-3"
                        isDisabled={usersLoading}
                      />
                    ) : (
                      <input
                        {...formik.getFieldProps('ownerId')}
                        className={clsx(
                          'form-control form-control-lg',
                          { 'is-invalid': formik.touched.ownerId && formik.errors.ownerId },
                        )}
                        type='text'
                        name='ownerId'
                        autoComplete='off'
                        onInput={(e) => handleCaps(e)}
                        disabled
                      />
                    )
                  }
                </div>
                {formik.touched.ownerId && formik.errors.ownerId && (
                  <div className='fv-plugins-message-container text-danger'>
                    <span role='alert' className="text-danger">{formik.errors.ownerId}</span>
                  </div>
                )}
                {/* Merchants */}
                <label className='form-label fs-6 fw-bolder text-dark required'>{settings.merchant_title}</label>
                <div className="row mb-3">
                  <VirtualizedSelect
                    options={merchantData}
                    placeholder={`${intl.formatMessage({ id: 'FORM.ACTION.CHOOSE' })} ${settings.merchant_title}`}
                    value={merchantData.map(merchanttemplate => merchanttemplate.options).flat().find((option) => option.value === formik.values.merchant) || null}
                    onChange={
                      option => formik.handleChange({
                        target: {
                          name: "merchant",
                          value: option?.value || ""
                        }
                      })
                    }
                    onBlur={
                      () => formik.values.merchant === "" && formik.setFieldTouched("merchant", true)
                    }
                    className="col-10 z-index-2"
                    isDisabled={merchantsLoading}
                  />
                  <button type="button" className="btn btn-secondary col-2 btn-sm" onClick={() => {
                    setShowAddMerchantModal(true);
                  }}>
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
                {formik.touched.merchant && formik.errors.merchant && (
                  <div className='fv-plugins-message-container text-danger'>
                    <span role='alert' className="text-danger">{formik.errors.merchant}</span>
                  </div>
                )}
                {/* label */}
                {
                  user.data.company_id !== companyId.esb && selectMultiMeeting.isFeatureLabelEnabled &&
                  <>
                    <label className='form-label fs-6 fw-bolder text-dark '>{intl.formatMessage({ id: 'FORM.LABEL.LABELS' })}</label>
                    <div className="input-group mb-3">
                      <Select
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999
                          })
                        }}
                        closeMenuOnSelect={false}
                        openMenuOnClick
                        isMulti
                        options={labelsOption}
                        placeholder={`${intl.formatMessage({ id: 'FORM.ACTION.CHOOSE' })} ${intl.formatMessage({ id: 'FORM.LABEL.LABELS' })}`}
                        value={labelsOption && Array.isArray(labelsOption)
                          ? labelsOption.filter((option: any) =>
                            formik.values.labels.includes(option.value)
                          )
                          : []}
                        onChange={(selectedOptions) => {
                          const selectedValues = selectedOptions
                            ? selectedOptions.map((option: any) => option.value)
                            : []
                          formik.setFieldValue('labels', selectedValues)
                        }}
                        className='w-100'
                        onBlur={() =>
                          formik.values.labels === '' &&
                          formik.setFieldTouched('labels', true)
                        }
                      />
                    </div>
                    {formik.touched.labels && formik.errors.labels && (
                      <div className='fv-plugins-message-container text-danger'>
                        <span role='alert' className="text-danger">{formik.errors.labels}</span>
                      </div>
                    )}
                  </>
                }
                {/* Date */}
                <label className='form-label fs-6 fw-bolder text-dark required'>{intl.formatMessage({ id: 'FORM.LABEL.DATE' }, { title: selectMultiMeeting.name })}</label>
                <div className="row mb-2">
                  {/* StartDate */}
                  <div className="input-group">
                    <DatePicker
                      oneTap
                      style={{ width: "100%", zIndex: "0" }}
                      cleanable={false}
                      editable={false}
                      format="dd/MM/yyyy"
                      container={document.querySelector('#add-report-meeting-modal') as HTMLElement}
                      value={formik.values.dateStart ? new Date(formik.values.dateStart) : null}
                      onChange={(value: any) => {
                        var date = moment(value).format('YYYY-MM-DD');

                        if (typeMeeting === "schedule") {
                          if (value && !isBefore(new Date(date), startOfToday())) {
                            formik.setFieldValue('dateStart', value)
                            formik.setFieldValue('dateEnd', value)
                          } else {
                            formik.setFieldValue('dateStart', null)
                            formik.setFieldValue('dateEnd', null)
                          }
                        } else {
                          if (value && !isAfter(new Date(date), new Date())) {
                            formik.setFieldValue('dateStart', value)
                            formik.setFieldValue('dateEnd', value)
                          } else {
                            formik.setFieldValue('dateStart', null)
                            formik.setFieldValue('dateEnd', null)
                          }
                        }
                      }}
                      shouldDisableDate={date => {
                        if (typeMeeting === "schedule") return isBefore(date, startOfToday());
                        else return isAfter(date, new Date());
                      }}
                    />
                  </div>
                  {formik.touched.dateStart && formik.errors.dateStart && (
                    <div className='fv-plugins-message-container text-danger'>
                      <span role='alert' className="text-danger">{formik.errors.dateStart}</span>
                    </div>
                  )}
                </div>
                {
                  !isAllDay &&
                  <>
                    <div className="row mb-2">
                      <div className="col-6">
                        {/* StartHour */}
                        <label className='form-label fs-6 fw-bolder text-dark required'>{intl.formatMessage({ id: "FORM.LABEL.HOUR_START" }, { title: "" })}</label>
                        <div className="input-group">
                          <DatePicker
                            style={{ width: "100%", zIndex: "0" }}
                            cleanable={false}
                            editable={false}
                            format="HH:mm"
                            container={document.querySelector('#add-report-meeting-modal') as HTMLElement}
                            value={formik.values.dateStart ? new Date(formik.values.dateStart) : null}
                            onChange={(value: any) => {
                              if (value) {
                                var val = moment(value).format('YYYY-MM-DD HH:mm');
                                var now = moment().format('YYYY-MM-DD HH:mm');
                                var isBeforeDate = moment(val).isBefore(now)
                                var isAfterDate = moment(val).isAfter(now)

                                if (typeMeeting === "schedule" && isBeforeDate) formik.setFieldValue('dateStart', new Date())
                                else if (typeMeeting === "report" && isAfterDate) formik.setFieldValue('dateStart', new Date())
                                else formik.setFieldValue('dateStart', value)
                              } else formik.setFieldValue('dateStart', null)
                            }}
                            shouldDisableHour={(hour: number, date: Date) => {
                              const selectedDate = moment(date);
                              const now = moment();

                              if (selectedDate.isSame(now, 'day')) {
                                return typeMeeting === "schedule" ? hour < now.hour() : hour > now.hour();
                              }
                              return false;
                            }}
                            shouldDisableMinute={(minute: number, date: Date) => {
                              const selectedDate = moment(date);
                              const now = moment();

                              if (selectedDate.isSame(now, 'hour')) {
                                return typeMeeting === "schedule" ? minute < now.minute() : minute > now.minute();
                              }
                              return false;
                            }}
                          />
                        </div>
                        {formik.touched.dateStart && formik.errors.dateStart && (
                          <div className='fv-plugins-message-container text-danger'>
                            <span role='alert' className="text-danger">{formik.errors.dateStart}</span>
                          </div>
                        )}
                      </div>
                      <div className="col-6">
                        {/* EndHour */}
                        <label className='form-label fs-6 fw-bolder text-dark required'>{intl.formatMessage({ id: "FORM.LABEL.HOUR_END" }, { title: "" })}</label>
                        <div className="input-group">
                          <DatePicker
                            style={{ width: "100%", zIndex: "0" }}
                            cleanable={false}
                            editable={false}
                            placement="bottomEnd"
                            format="HH:mm"
                            container={document.querySelector('#add-report-meeting-modal') as HTMLElement}
                            value={formik.values.dateEnd ? new Date(formik.values.dateEnd) : null}
                            onChange={(value: any) => {
                              if (value) {
                                var val = moment(value).format('YYYY-MM-DD HH:mm');
                                var now = moment().format('YYYY-MM-DD HH:mm');
                                var isBeforeDate = moment(val).isBefore(now)
                                var isAfterDate = moment(val).isAfter(now)

                                if (typeMeeting === "schedule" && isBeforeDate) formik.setFieldValue('dateEnd', new Date())
                                else if (typeMeeting === "report" && isAfterDate) formik.setFieldValue('dateEnd', new Date())
                                else formik.setFieldValue('dateEnd', value)
                              } else formik.setFieldValue('dateEnd', null)
                            }}
                            shouldDisableHour={(hour: number, date: Date) => {
                              const selectedDate = moment(date);
                              const now = moment();

                              if (selectedDate.isSame(now, 'day')) {
                                return typeMeeting === "schedule" ? hour < now.hour() : hour > now.hour();
                              }
                              return false;
                            }}
                            shouldDisableMinute={(minute: number, date: Date) => {
                              const selectedDate = moment(date);
                              const now = moment();

                              if (selectedDate.isSame(now, 'hour')) {
                                return typeMeeting === "schedule" ? minute < now.minute() : minute > now.minute();
                              }
                              return false;
                            }}
                          />
                        </div>
                        {formik.touched.dateEnd && formik.errors.dateEnd && (
                          <div className='fv-plugins-message-container text-danger'>
                            <span role='alert' className="text-danger">{formik.errors.dateEnd}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                }
                <div className="form-check mb-3">
                  <label className="form-check-label" htmlFor="isAllDay">
                    Sepanjang hari
                  </label>
                  <input className="form-check-input" type="checkbox" id="isAllDay"
                    checked={isAllDay}
                    onChange={() => {
                      setIsAllDay(!isAllDay)

                      if (isAllDay) {
                        formik.handleChange({
                          target: {
                            name: "dateEnd",
                            value: formik.values.dateStart ? new Date(formik.values.dateStart) : null
                          }
                        })
                      }
                    }}
                  />
                </div>
                {/* Attachments */}
                {
                  !settings.meeting_done_disable_capture_camera ?
                    <>
                      <label className={`form-label fs-6 fw-bolder text-dark required`}>{intl.formatMessage({ id: 'FORM.LABEL.PHOTO' }, { title: selectMultiMeeting.name })}</label>
                      <InputAttachment keyString={'attachment'} formik={formik} isMulti={false} type="input" accept="image/png, image/jpeg, image/jpg" />
                    </>
                    :
                    <>
                      {!settings.meeting_visit_disable_capture_camera && (
                        <>
                          <label className="form-label fs-6 fw-bolder text-dark">
                            {intl.formatMessage({ id: 'FORM.LABEL.PHOTO' }, { title: selectMultiMeeting.name })}
                          </label>

                          {camera.isCamera ? (
                            <CapturePhoto
                              keyString="report"
                              img={capturePhoto!}
                              setImg={setCapturePhoto!}
                              func={handleTakePhoto}
                              modalBtnLoading={formik.isSubmitting!}
                            />
                          ) : (
                            <div className="mb-5 alert alert-danger">
                              <div className="alert-text font-weight-bold">
                                {intl.formatMessage({ id: 'ATTENDANCE.PERMISSIONS.ALERT1' }, { title: intl.formatMessage({ id: 'ATTENDANCE.PERMISSIONS.CAMERA' }) })}<br /><br />
                                <b>{intl.formatMessage({ id: 'ATTENDANCE.PERMISSIONS.ALERT2' }, { title: intl.formatMessage({ id: 'ATTENDANCE.PERMISSIONS.CAMERA' }) })}</b><br />
                                {intl.formatMessage({ id: 'ATTENDANCE.PERMISSIONS.ALERT3' })}<br />
                                {intl.formatMessage({ id: 'ATTENDANCE.PERMISSIONS.ALERT4' }, { title: intl.formatMessage({ id: 'ATTENDANCE.PERMISSIONS.CAMERA' }) })}
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </>

                }
                {formik.touched.attachment && formik.errors.attachment && (
                  <div className='fv-plugins-message-container text-danger'>
                    <span role='alert' className="text-danger">{formik.errors.attachment}</span>
                  </div>
                )}
                {/* Coordinat Location */}
                <span className='form-label fs-6 fw-bolder text-dark required'>{intl.formatMessage({ id: 'FORM.LABEL.LOCATION' })}</span><br />
                <small>{intl.formatMessage({ id: 'FORM.GUIDE.ACTIVE_GPS' })}</small>
                <div className="d-flex">
                  <div className="input-group mb-3">
                    <input
                      {...formik.getFieldProps('location')}
                      className={clsx(
                        'form-control form-control-lg me-3',
                        { 'is-invalid': formik.touched.location && formik.errors.location },
                      )}
                      type='text'
                      name='location'
                      autoComplete='off'
                      disabled={true}
                    />
                  </div>
                  <button type="button" className="btn btn-secondary mb-3" onClick={() => handleCoordinate({ setLatitudeMap, setLongitudeMap, intl, formik })}>
                    <i className="fas fa-search"></i>
                  </button>
                </div>
                {formik.touched.location && formik.errors.location && (
                  <div className='fv-plugins-message-container text-danger'>
                    <span role='alert' className="text-danger">{formik.errors.location}</span>
                  </div>
                )}
                {/* Map Location */}
                <MapLocationMeeting latitudeMap={latitudeMap} longitudeMap={longitudeMap} typeMeeting={typeMeeting} />
                {/* Participant */}
                <label className={`form-label fs-6 fw-bolder text-dark ${user?.data.company_id === companyId.maxy && 'required'}`}>{intl.formatMessage({ id: 'FORM.LABEL.PARTICIPANT' })}</label>
                <div className="input-group mb-3">
                  <Select
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999
                      })
                    }}
                    openMenuOnClick
                    closeMenuOnSelect={false}
                    options={userCompanyData}
                    placeholder={`${intl.formatMessage({ id: 'FORM.ACTION.CHOOSE' })} ${intl.formatMessage({ id: 'FORM.LABEL.PARTICIPANT' })}`}
                    isMulti
                    value={formik.values.userAttendees}
                    className="w-100"
                    isDisabled={usersLoading}
                    onChange={handleAttendeesChange}
                  />
                </div>
                {/* Menambahkan error di FORM.LABEL.PARTICIPANT */}
                {formik.touched.userAttendees && formik.errors.userAttendees && (
                  <div className='fv-plugins-message-container text-danger'>
                    <span role='alert' className="text-danger">{formik.errors.userAttendees}</span>
                  </div>
                )}
                {/* Note */}
                {
                  user?.data.company_id === companyId.maxy ? (
                    <label className='form-label fs-6 fw-bolder text-dark'>{intl.formatMessage({ id: 'FORM.LABEL.DISCUSSION_NOTES' })}</label>
                  ) : (
                    <label className='form-label fs-6 fw-bolder text-dark'>{intl.formatMessage({ id: 'FORM.LABEL.NOTE' })}</label>
                  )
                }
                <div className="input-group mb-3">
                  <textarea
                    placeholder={intl.formatMessage({ id: 'FORM.LABEL.NOTE' })}
                    id="floatingTextarea"
                    {...formik.getFieldProps('note')}
                    className={clsx(
                      'form-control form-control-lg',
                      { 'is-invalid': formik.touched.note && formik.errors.note },
                    )}
                    style={{ zIndex: 0 }}
                    name="note"
                    onInput={(e) => handleCaps(e)}
                  >
                  </textarea>
                </div>
                {formik.touched.note && formik.errors.note && (
                  <div className='fv-plugins-message-container text-danger'>
                    <span role='alert' className="text-danger">{formik.errors.note}</span>
                  </div>
                )}
                {/* Google Calendar Checkbox */}
                {
                  (user?.data?.sync_google_calendar) && (
                    <div className="form-check mb-3">
                      <label className="form-check-label fw-bold" htmlFor="toGoogleCalendar">
                        {intl.formatMessage({ id: 'FORM.LABEL.TO_GOOGLE_CALENDAR' }) || 'Add to Google Calendar'}
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="toGoogleCalendar"
                        checked={toGoogleCalendar}
                        onChange={() => setToGoogleCalendar(!toGoogleCalendar)}
                      />
                    </div>
                  )
                }
                {customFields &&
                  <RenderCustomFieldGeneralForm
                    customFieldGeneral={customFields}
                    formik={formik}
                    errors={formik.errors}
                    containerRef={document.querySelector('#add-report-meeting-modal') as HTMLElement}
                    typeMeeting={typeMeeting as 'schedule' | 'report' | 'visit'}
                    typeAction="add"
                  />
                }
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light d-none"
                  data-bs-dismiss="modal"
                  ref={closeModalRef}
                >
                  {intl.formatMessage({ id: "FORM.ACTION.CANCEL" })}
                </button>
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={handleCloseModal}
                >
                  {intl.formatMessage({ id: "FORM.ACTION.CANCEL" })}
                </button>
                <button type="submit" className={`btn btn-primary me-10 ${formik.isSubmitting ? "disabled" : ""}`} data-kt-indicator={formik.isSubmitting ? 'on' : 'off'}>
                  <span className="indicator-label">
                    {intl.formatMessage({ id: 'FORM.ACTION.ADD' })}
                  </span>
                  <span className="indicator-progress">
                    Loading... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {
        showAddMerchantModal && <AddMerchant addMerchant={addMerchant} />
      }
    </>
  )
}

export default AddReportMeeting